import React, { useEffect, useState } from 'react';
import { Button, Form, Input, message, Upload } from 'antd';
import PropTypes from 'prop-types';
import { UploadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useAuthContext from '../../contexts/AuthContext';

const { TextArea } = Input;

export const BugModal = ({ setDescribeBug, handleCloseModalHelp }) => {
  const [form] = Form.useForm();
  const { dispatchAPI, user } = useAuthContext();
  const { t } = useTranslation();
  const [upload, setUpload] = useState(null);

  const sendMailHelp = async (body) => {
    try {
      const formData = new FormData();
      formData.append('values', JSON.stringify(body));
      formData.append('file', upload);
      await dispatchAPI('POST', {
        url: `reclamations/sendSBBug`,
        body: formData
      });
      message.success(t(`basiclayout.footer.modal_bug_success`));
      setDescribeBug(false);
      setUpload();
    } catch (e) {
      if (e.response) message.error(e.response.status);
    }
  };

  const handleSubmit = (values) => {
    sendMailHelp(values);
    handleCloseModalHelp();
  };

  useEffect(() => {
    if (user)
      form.setFieldsValue({ ...user.insurer, object: 'Problème informatique' });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Form
        name="helpForm"
        form={form}
        labelCol={{ span: 9 }}
        wrapperCol={{ span: 9 }}
        autoComplete="off"
        onFinish={handleSubmit}
      >
        <Form.Item label={t('basiclayout.footer.name_office')} name="name">
          <Input />
        </Form.Item>
        <Form.Item
          label={t('basiclayout.footer.first_name')}
          name="owner_first_name"
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t('basiclayout.footer.last_name')}
          name="owner_last_name"
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t('basiclayout.footer.phone_number')}
          name="phone_number"
        >
          <Input />
        </Form.Item>
        <Form.Item label={t('basiclayout.footer.email')} name="owner_email">
          <Input />
        </Form.Item>
        <Form.Item label={t('basiclayout.footer.object')} name="object">
          <Input />
        </Form.Item>
        <Form.Item label={t('basiclayout.footer.message')} name="content">
          <TextArea />
        </Form.Item>
        <Form.Item name="attachments" wrapperCol={{ offset: 8, span: 9 }}>
          <Upload
            maxCount={1}
            beforeUpload={(file) => {
              setUpload(file);
              return false;
            }}
            onRemove={() => setUpload()}
          >
            <Button icon={<UploadOutlined />}>{t('buttons.upload')}</Button>
          </Upload>
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 9 }}>
          <Button type="primary" htmlType="submit">
            Envoyer
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

BugModal.propTypes = {
  setDescribeBug: PropTypes.func.isRequired,
  handleCloseModalHelp: PropTypes.func.isRequired
};

export default BugModal;
